import { render, staticRenderFns } from "./GDPRViewer.vue?vue&type=template&id=6f99b16a&scoped=true&"
import script from "./GDPRViewer.vue?vue&type=script&lang=js&"
export * from "./GDPRViewer.vue?vue&type=script&lang=js&"
import style0 from "./GDPRViewer.vue?vue&type=style&index=0&id=6f99b16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99b16a",
  null
  
)

export default component.exports